import { Controller } from '@hotwired/stimulus'
import moment from 'moment'

export default class extends Controller {
  static targets = ['startDate', 'endDate']

  connect() {
    this.initializePicker(this.startDateTarget)
    this.initializePicker(this.endDateTarget)
  }

  initializePicker(element) {
    $(element).datetimepicker({
      format: 'DD MMMM YYYY HH:mm',
      defaultDate: null,
      minDate: moment().startOf('day'),
      maxDate: moment().add(3, 'years'),
      useCurrent: false
    })
  }
}
